import { useTranslation } from "react-i18next";
import { useStatusesStore } from "../../../../../../store/admin/statusesStore";
import type { ThemeClasses } from "../types";
import { Combobox } from "../../../../../../components/ui";
import { getStatusOptionsForEntity } from "../../../../../../utils/getStatusEntity";

interface RouteFiltersProps {
  status_id: string;
  searchQuery: string;
  themeClasses: ThemeClasses;
  onStatusChange: (value: string | null) => void;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function RouteFilters({
  status_id,
  searchQuery,
  themeClasses,
  onStatusChange,
  onSearchChange,
}: RouteFiltersProps) {
  const { t } = useTranslation("adminSections");

  const statuses = useStatusesStore((state) => state.statuses);
  const statusOptionsSelect = getStatusOptionsForEntity(statuses, "routes", t);

  return (
    <div className="flex items-center flex-1 sm:flex-row flex-col gap-4 w-full">
      {/* Estado */}
      <div className="sm:min-w-[200px] min-w-full">
        <Combobox
          options={statusOptionsSelect}
          placeholder={t("routes.filters.selectStatus")}
          value={statusOptionsSelect.find((opt) => opt.value === status_id) || null}
          onChange={(option) => onStatusChange(option?.value || null)}
          isSearchable
          isClearable
          noOptionsMessage={() => t("routes.filters.noStatusesAvailable")}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </div>
      {/* Búsqueda */}
      <div className="relative sm:max-w-md w-full">
        <i
          className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 ${themeClasses.textSecondary}`}
        ></i>
        <input
          type="text"
          value={searchQuery}
          onChange={onSearchChange}
          placeholder={t("routes.searchPlaceholder")}
          className={`w-full pl-10 pr-4 h-10 bg-app border ${themeClasses.cardBorder} rounded-lg ${themeClasses.text} text-sm focus:outline-none focus:ring-2 focus:ring-primary-500`}
        />
      </div>
    </div>
  );
}
